import Vue from 'vue';
import './video_player';

Vue.component('quiz-question', {
  props: ['question', 'index', 'options', 'isCurrent', 'displayCorrect', 'displayResults'],
  data: function () {
    return {
      questionHasFocus: this.isCurrent,
    };
  },
  methods: {
    i18n: function (str) {
      return i18n.__(str);
    },
    answer: function (idx) {
      if (!this.options.locked) {
        this.$emit('questionAnswered', this.question, idx);
      }
    },
    alternativeMediaUUID: function (media) {
      if (media.mime.match(/video/)) {
        return media.data;
      } else {
        return false;
      }
    },
    getCorrectAlternative: function () {
      let correctAlternative = null;
      for (var i = 0; i < this.question.alternatives.length; i++) {
        if (this.question.alternatives[i].correct) {
          correctAlternative = this.question.alternatives[i];
          break;
        }
      }
      return correctAlternative;
    },
    alternativeCorrectionClass: function (alternative) {
      if (this.displayCorrect) {
        let correctAlternative = this.getCorrectAlternative();
        if (!correctAlternative) {
          return {
            'lp--quizWidgetAlternativeCorrectAnswered': alternative.answered && this.displayResults,
          };
        } else {
          return {
            'lp--quizWidgetAlternativeCorrect': alternative.correct,
            'lp--quizWidgetAlternativeCorrectAnswered':
              alternative.answered && alternative.correct && this.displayResults,
            'lp--quizWidgetAlternativeIncorrect': alternative.answered && !alternative.correct && this.displayResults,
          };
        }
      } else {
        return {};
      }
    },
    getTabIndex: function (alternative) {
      return this.displayResults && alternative.answered ? -1 : 0;
    },
  },
  computed: {
    mediaUUID: function () {
      if (this.question.media.mime.match(/video/)) {
        return this.question.media.data;
      } else {
        return false;
      }
    },
    dynamicClasses: function () {
      let classes = {
        'lp--quizWidgetQuestionActive': this.displayCorrect ? true : this.questionHasFocus,
      };
      if (this.displayCorrect) {
        let correctAlternative = this.getCorrectAlternative();
        let hasAnswered = this.question.alternatives.some(function (alternative) {
          return alternative.answered;
        });
        classes['lp--quizWidgetQuestionIncorrect'] =
          correctAlternative && hasAnswered && !correctAlternative.answered && this.displayResults;
        classes['lp--quizWidgetQuestionCorrect'] =
          (!correctAlternative || (correctAlternative && correctAlternative.answered)) && this.displayResults;
      }
      return classes;
    },
  },
  template: `
  <li class="lp--quizWidgetQuestion" v-bind:class="dynamicClasses" v-bind:data-question-id="question.id">

    <div class="lp--quizWidgetQuestionHeader">
      <div class="lp--quizWidgetQuestionHeaderTools">
        <h2>{{index+1}}</h2>
        <p class="lp--quizWidgetQuestionBodyText" v-html="question.body"></p>
      </div>
      </div>

      <div class="lp--quizWidgetQuestionBody" v-if="question.media">
        <div class="lp--quizWidgetQuestionBodyMedia" v-if="question.media" v-bind:data-video-uuid="mediaUUID" v-bind:style="{backgroundImage: 'url(' + question.media.preview + ')'}">
          <quiz-video-player :video="question.media" :options="options" v-if="question.media && question.media.mime.match(/video/)" />
        </div>
      </div>

      <div class="lp--quizWidgetQuestionAlternatives">
        <ol class="lp--quizWidgetQuestionAlternativesList">
          <li class="lp--quizWidgetAlternative" v-bind:class="alternativeCorrectionClass(alternative)" v-for="(alternative, alt_index) in question.alternatives">

            <div class="lp--quizWidgetAlternativeBodyContainer">

                <div class="lp--quizWidgetAlternativeBodyMedia" v-if="alternative.media" v-bind:data-video-uuid="alternativeMediaUUID(alternative.media)" v-bind:style="{backgroundImage: 'url(' + alternative.media.preview + ')'}">
                  <quiz-video-player :video="alternative.media" :options="options" v-if="alternative.media && alternative.media.mime.match(/video/)" />
                </div>

              <div v-bind:id="question.id + '_' + alternative.id" class="lp--quizWidgetAlternativeBodyText" v-html="alternative.body"></div>

              <div class="lp--quizWidgetAlternativeBodyAction">
                <a href="#" @focus="questionHasFocus = true" @blur="questionHasFocus = false" v-bind:tabindex="getTabIndex(alternative)" v-bind:aria-labelledby="question.id + '_' + alternative.id" v-on:click.stop.prevent="answer(alt_index)" v-on:keyup.enter="answer(alt_index)" v-bind:class="{'lp--quizWidgetAlternativeAction': true, 'lp--quizWidgetSelectedAlternative': (displayResults && alternative.answered)}" :title="i18n('quiz_mark_correct_answer')"></a>
              </div>

            </div>

          </li>
        </ol>
      </div>
  </li>
  `,
});
